"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDrawer = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var _drawer_1 = tslib_1.__importDefault(require("../_drawer"));
var Footer_1 = tslib_1.__importDefault(require("./Footer"));
var withBackTitle_1 = tslib_1.__importDefault(require("./withBackTitle"));
require("./style");
var CustomDrawer = function (props) {
    var _a = props.width, width = _a === void 0 ? 988 : _a, dataSource = props.dataSource, onClose = props.onClose, activeKey = props.activeKey, rest = tslib_1.__rest(props, ["width", "dataSource", "onClose", "activeKey"]);
    var mainPageKey = props.mainPageKey;
    if (!mainPageKey) {
        mainPageKey = dataSource[0].key;
    }
    var activeItem = dataSource.find(function (item) {
        return item.key === activeKey;
    });
    if (!activeItem) {
        return null;
    }
    var _b = activeItem.withFooter, withFooter = _b === void 0 ? true : _b;
    var bodyStyle = {
        padding: 0,
    };
    var func = function () { };
    var isMainPage = activeKey === mainPageKey;
    var title = isMainPage
        ? activeItem.title
        : (0, withBackTitle_1.default)(activeItem.title, activeItem.onCancel || func);
    var content = (react_1.default.createElement("div", { style: {
            padding: 24,
            height: withFooter ? 'calc(100vh - 120px)' : 'calc(100vh - 55px)',
            overflow: 'auto',
        } }, activeItem.content));
    var handleClose = function (e) {
        if (isMainPage) {
            onClose && onClose(e);
        }
        else {
            activeItem.onCancel && activeItem.onCancel();
        }
    };
    return (react_1.default.createElement(_drawer_1.default, tslib_1.__assign({ maskClosable: false, onClose: onClose, width: width, bodyStyle: bodyStyle, title: title }, rest),
        content,
        react_1.default.createElement(Footer_1.default, { mainPageKey: mainPageKey, activeKey: activeKey, isDisable: activeItem.disableOk, handleOk: activeItem.onOk || func, handleCancel: handleClose, okText: activeItem.okText, cancelText: activeItem.cancelText })));
};
exports.CustomDrawer = CustomDrawer;
exports.default = CustomDrawer;
//# sourceMappingURL=index.js.map